<template>
    <b-container class="mt120">
        <b-row class="">
            <b-col class="processTestimony center" md="6" sm="12">
                <img class="quoteIcon" :src="getImg(testimony.imgQuote, 'imagesProcess')" alt="Testimony quote icon">
                <img class="br50" :src="getImg(testimony.img, 'imagesHome')" :alt="testimony.name">
                <p class="bold">{{testimony.msg}}</p>
                <p class="pink">{{testimony.name}}</p>
                <p>{{testimony.position}}</p>
                <hr class="testimonyHr">
                <p class="bold">{{$t('brands.title')}}</p>
                <DiscussBtn @click="test()" />
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import json from '@/locales/en.json'
import DiscussBtn from '@/components/DiscussBtn.vue'

export default {
    name: "ProcessTestimony",
    data: function() {
        return {
            testimony: json.pageProcess.testimony
        }
    },
    components: {
        DiscussBtn
    },
    methods: {
        getImg: function(img,env) {
            return require('@/assets/'+env+'/'+img)
        },
        test: function() {
            console.log('test')
        }
    }
}
</script>

<style lang="scss" scoped>
img.br50{
    width:65px;
    margin-bottom:15px;
}

.testimonyHr{
    width:50%;
}

.processTestimony{
    max-width:60%;
    margin:auto;
    background-color:#F7F7F7;
    padding:60px 120px;
}

.quoteIcon{
    position: absolute;
    top: -70px;
    right: -70px;
    width: 170px;
}

@media (max-width:991px) {
    .processTestimony {
        max-width:90%;
        padding: 20px;
    }

    .quoteIcon {
        top: -57px;
        right: -5px;
        width: 100px;
    }
}

</style>